import { EventService } from '@nextgen-web-framework/core';

import { WebEventsVersionsEnum, WebPublishEventType, WebEventDataInterface } from './types';

// timestamp as per setup pubsub requried
const getEventTimeStamp = () => new Date();

// setting source system as metadata for web
const getEventSourceSystem = () => 'web.component';

// define version
const getCurrentEventVersion = () => WebEventsVersionsEnum['1.0.0'];

// Get topic name for pubsub events
export const getEventTopicName = (event: string) => `web.domain.${event}`;

const getMetaData = (event: string) => ({
  timestamp: getEventTimeStamp(),
  sourceSystem: getEventSourceSystem(),
  eventName: event,
  version: getCurrentEventVersion(),
});

export const WebEvents = {
  publishEvent({ event, payload, sync = false, transformer }: WebPublishEventType) {
    const eventData: WebEventDataInterface = {
      metadata: getMetaData(event),
      ...(payload && { ...payload }),
    };
    if (sync) {
      EventService.publishSync(getEventTopicName(event), eventData, transformer);
    } else {
      EventService.publish(getEventTopicName(event), eventData, transformer);
    }
  },
};
